import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { setLocationLabel as setLocationLabelQuery } from '#/trip-planner/queries';
import ROUTES from '#/constants/routes';
import useCurrentQueryRedirect from './useCurrentQueryRedirect';
import useNavigate from './useNavigate';

export default () => {
  const { navigate } = useNavigate();
  const dispatch = useDispatch();
  const { currentQueryRedirect } = useCurrentQueryRedirect();

  const navigateToPlanner = useCallback(() => {
    navigate(ROUTES.planner);
  }, [navigate]);
  const navigateToTrip = useCallback(() => {
    navigate(ROUTES.trip);
  }, [navigate]);

  const setLocationLabelAndRedirect = useCallback(
    (locType, lat, lon) => {
      dispatch(
        setLocationLabelQuery(locType, { lat, lon }, () => {
          currentQueryRedirect(locType, navigateToPlanner, navigateToTrip);
        })
      );
    },
    [dispatch, navigateToPlanner, navigateToTrip, currentQueryRedirect]
  );
  const setLocationLabel = useCallback(
    (locType, lat, lon, next = () => {}) => {
      dispatch(setLocationLabelQuery(locType, { lat, lon }, next));
    },
    [dispatch]
  );

  return { setLocationLabelAndRedirect, setLocationLabel };
};
